export default "__VITE_ASSET__DW7sPBp5__"